import _toConsumableArray from "@babel/runtime-corejs3/helpers/toConsumableArray";
import _extends from "@babel/runtime-corejs3/helpers/extends";
import _slicedToArray from "@babel/runtime-corejs3/helpers/slicedToArray";
import _includesInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/includes";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";
import _spliceInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/splice";
import _sliceInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/slice";
import * as React from 'react';
import classNames from 'classnames';
import { tuple } from '../_utils/type';
import { getCompProps } from '../_utils';
import { ConfigContext } from '../config-provider';
import usePopper from '../_utils/usePopper';
import Input from '../input';
import Icon from '../icon';
import Empty from '../empty';
export var CascaderPlacement = tuple('topLeft', 'topRight', 'bottomLeft', 'bottomRight');
var Cascader = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var _React$useContext = React.useContext(ConfigContext),
      getPrefixCls = _React$useContext.getPrefixCls,
      pkgPrefixCls = _React$useContext.prefixCls,
      userDefaultProps = _React$useContext.compDefaultProps; // 属性需要合并一遍用户定义的默认属性


  var allProps = getCompProps('Cascader', userDefaultProps, props);
  var style = allProps.style,
      options = allProps.options,
      children = allProps.children,
      loadData = allProps.loadData,
      className = allProps.className,
      fieldNames = allProps.fieldNames,
      placeholder = allProps.placeholder,
      defaultValue = allProps.defaultValue,
      displayRender = allProps.displayRender,
      expandTrigger = allProps.expandTrigger,
      changeOnSelect = allProps.changeOnSelect,
      dropdownRender = allProps.dropdownRender,
      notFoundContent = allProps.notFoundContent,
      getPopupContainer = allProps.getPopupContainer,
      defaultPopupVisible = allProps.defaultPopupVisible,
      onPopupVisibleChange = allProps.onPopupVisibleChange,
      onPopperVisibleChange = allProps.onPopperVisibleChange,
      customPrefixcls = allProps.prefixCls; // className前缀

  var prefixCls = getPrefixCls(pkgPrefixCls, 'cascader', customPrefixcls);
  var pickerRef = React.useRef();
  var triggerRef = React.useRef();
  var mergeRef = ref || pickerRef;

  var _React$useState = React.useState(!!props.popperVisible || !!props.popupVisible || defaultPopupVisible),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      visible = _React$useState2[0],
      setVisible = _React$useState2[1];

  React.useEffect(function () {
    setVisible(!!props.popperVisible || !!props.popupVisible);
  }, [props.popperVisible, props.popupVisible]);

  var _React$useState3 = React.useState([options]),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      menus = _React$useState4[0],
      setMenus = _React$useState4[1];

  var _React$useState5 = React.useState([]),
      _React$useState6 = _slicedToArray(_React$useState5, 2),
      currentOptions = _React$useState6[0],
      setCurrentOptions = _React$useState6[1];

  var _React$useState7 = React.useState([]),
      _React$useState8 = _slicedToArray(_React$useState7, 2),
      selectedOptions = _React$useState8[0],
      setSelectedOptions = _React$useState8[1];

  var _React$useState9 = React.useState(props.value || defaultValue || []),
      _React$useState10 = _slicedToArray(_React$useState9, 2),
      value = _React$useState10[0],
      setValue = _React$useState10[1];

  React.useEffect(function () {
    props.value && setValue(props.value);
  }, [props.value]);
  React.useEffect(function () {
    if (value && (options === null || options === void 0 ? void 0 : options.length) > 0) {
      var _currentOptions = [];
      var _menus = [options];

      var scanOptions = function scanOptions(options) {
        options.forEach(function (option) {
          var _a;

          if (_includesInstanceProperty(value).call(value, String(option[fieldNames.value]))) {
            _currentOptions.push(option);

            if ((_a = option[fieldNames.children]) === null || _a === void 0 ? void 0 : _a.length) {
              _menus.push(option[fieldNames.children]);

              scanOptions(option[fieldNames.children]);
            }
          }
        });
      };

      scanOptions(options);
      setMenus(_menus);
      setCurrentOptions(_currentOptions);
    }
  }, [options, value, selectedOptions, fieldNames]);
  React.useEffect(function () {
    var _a;

    if (allProps.autoFocus) {
      (_a = mergeRef.current) === null || _a === void 0 ? void 0 : _a.focus();
    }
  }, [allProps.autoFocus, mergeRef]);

  var labels = _mapInstanceProperty(currentOptions).call(currentOptions, function (_ref) {
    var label = _ref[fieldNames.label];
    return label;
  });

  var allowClear = allProps.allowClear && value.length > 0;
  var locatorProps = {
    style: style,
    tabIndex: 0,
    className: classNames("".concat(prefixCls, "-picker"), className, {
      expand: visible,
      allowClear: allowClear,
      disabled: props.disabled
    })
  };

  var handleClear = function handleClear() {
    onChange([]);
  };

  var inputProps = {
    value: value,
    placeholder: placeholder,
    readOnly: true,
    disabled: props.disabled,
    className: classNames("".concat(prefixCls, "-picker-input"), {
      expand: visible
    }),
    suffix: props.suffixIcon || /*#__PURE__*/React.createElement(Icon, {
      type: "arrow-down",
      className: classNames({
        expand: visible
      })
    })
  };

  if (props.bordered) {
    inputProps.borderType = 'bordered';
  }

  var cascaderLocator = /*#__PURE__*/React.createElement("span", _extends({}, locatorProps, {
    ref: mergeRef
  }), React.Children.count(children) === 1 && children.type ? /*#__PURE__*/React.cloneElement(children, {
    ref: triggerRef
  }) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", {
    ref: triggerRef
  }, /*#__PURE__*/React.createElement(Input, _extends({}, inputProps)), /*#__PURE__*/React.createElement("span", {
    className: "".concat(prefixCls, "-picker-label")
  }, (labels === null || labels === void 0 ? void 0 : labels.length) ? displayRender(labels, currentOptions) : '')), allowClear && /*#__PURE__*/React.createElement(Icon, {
    type: "close-solid",
    className: "".concat(prefixCls, "-picker-close"),
    onClick: handleClear
  })));

  var onExpend = function onExpend(index, opt, opts) {
    _spliceInstanceProperty(selectedOptions).call(selectedOptions, index, selectedOptions.length - index, opt);

    setSelectedOptions(selectedOptions);

    var newMenus = _toConsumableArray(menus);

    if ((opts === null || opts === void 0 ? void 0 : opts.length) || opt.isLeaf === false) {
      _spliceInstanceProperty(newMenus).call(newMenus, index + 1, newMenus.length - index + 1, opts);
    }

    if (!(opts === null || opts === void 0 ? void 0 : opts.length) && opt.isLeaf !== false || changeOnSelect) {
      onChange(selectedOptions);
    }

    !(opts === null || opts === void 0 ? void 0 : opts.length) && opt.isLeaf !== false && setVisible(false);
    setMenus(newMenus);
    loadData && opt.isLeaf === false && !(opts === null || opts === void 0 ? void 0 : opts.length) && loadData(selectedOptions);
  };

  var onChange = function onChange(selectedOptions) {
    var selectedValue = _mapInstanceProperty(selectedOptions).call(selectedOptions, function (_ref2) {
      var value = _ref2[fieldNames.value];
      return value;
    });

    setCurrentOptions(selectedOptions);
    props.value === undefined && setValue(selectedValue);
    props.onChange && props.onChange(selectedValue, selectedOptions);
  };

  var onVisibleChange = function onVisibleChange(visible) {
    setVisible(visible);
    onPopupVisibleChange && onPopupVisibleChange(visible);
    onPopperVisibleChange && onPopperVisibleChange(visible);
    visible && setSelectedOptions(_sliceInstanceProperty(currentOptions).call(currentOptions, 0));
  };

  var cascaderMenus = /*#__PURE__*/React.createElement(React.Fragment, null, (options === null || options === void 0 ? void 0 : options.length) ? (menus === null || menus === void 0 ? void 0 : menus.length) && _mapInstanceProperty(menus).call(menus, function (opts, index) {
    return /*#__PURE__*/React.createElement("ul", {
      key: index,
      className: "".concat(prefixCls, "-menu")
    }, (opts === null || opts === void 0 ? void 0 : opts.length) && _mapInstanceProperty(opts).call(opts, function (opt) {
      var isLeaf = opt.isLeaf,
          loading = opt.loading,
          value = opt[fieldNames.value],
          label = opt[fieldNames.label],
          children = opt[fieldNames.children];
      var expendEvent = expandTrigger === 'click' || !(children && children.length) ? 'onClick' : 'onMouseEnter';
      var optionProps = {
        role: 'menuitem',
        className: classNames("".concat(prefixCls, "-menu-item"), {
          disabled: opt.disabled,
          last: !(children === null || children === void 0 ? void 0 : children.length) && isLeaf !== false,
          selected: selectedOptions[index] && selectedOptions[index][fieldNames.value] === value
        })
      };

      if (!opt.disabled) {
        optionProps[expendEvent] = onExpend.bind(null, index, opt, children);
      }

      return /*#__PURE__*/React.createElement("li", _extends({
        key: value
      }, optionProps, {
        title: label
      }), /*#__PURE__*/React.createElement("span", {
        className: "".concat(prefixCls, "-menu-item-label")
      }, label), loading ? /*#__PURE__*/React.createElement(Icon, {
        type: "loadding-circle",
        spin: true
      }) : ((children === null || children === void 0 ? void 0 : children.length) || isLeaf === false) && (props.expandIcon || /*#__PURE__*/React.createElement(Icon, {
        type: "arrow-right"
      })));
    }));
  }) : /*#__PURE__*/React.createElement(Empty, {
    description: notFoundContent
  }));
  var cascaderPopper = dropdownRender(cascaderMenus);

  var popperProps = _extends(_extends({}, allProps), {
    gap: 4,
    visible: visible,
    onVisibleChange: onVisibleChange,
    trigger: 'click',
    getPopupContainer: getPopupContainer,
    prefixCls: "".concat(prefixCls, "-menus"),
    placement: allProps.popperPlacement || allProps.popupPlacement,
    popperClassName: allProps.popperClassName || allProps.popupClassName,
    getTriggerElement: function getTriggerElement() {
      return triggerRef.current;
    }
  });

  return usePopper(cascaderLocator, cascaderPopper, popperProps);
});
Cascader.displayName = 'Cascader';
export default Cascader;